import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const SoundMaxIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 14"
  >
    <path d="M9 .878C9 .176 8.264-.263 7.69.176L3.028 3.51H.818c-.49 0-.818.35-.818.877V9.65c0 .526.327.877.818.877h2.21l4.663 3.334c.573.351 1.309 0 1.309-.702zM12.596 1.343a.75.75 0 0 1 1.06 0 8 8 0 0 1 0 11.314.75.75 0 0 1-1.06-1.06 6.5 6.5 0 0 0 0-9.193.75.75 0 0 1 0-1.06" />
    <path d="M11.536 3.464a.75.75 0 1 0-1.061 1.061 3.5 3.5 0 0 1 0 4.95.75.75 0 1 0 1.06 1.06 5 5 0 0 0 0-7.07" />
  </svg>
);
SoundMaxIcon.displayName = 'SoundMaxIcon';
export default SoundMaxIcon;
